import { useQuery } from "@tanstack/react-query";

import { fetchProgramByCustomId } from "../api";
import { ProgramResults } from "../../../types";

export function useProgramFetch({ matchId }: { matchId: string }) {
  const { data, isPending, isError } = useQuery({
    queryKey: ["program", matchId],
    queryFn: async () => {
      const response = await fetchProgramByCustomId({
        customId: matchId,
      });

      return (response || {}) as ProgramResults;
    },
    enabled: !!matchId,
    refetchOnWindowFocus: false,
  });

  return {
    program: data,
    isLoading: isPending,
    isError: isError,
  };
}
